import { CaretLeftIcon } from '@radix-ui/react-icons'
import React, { useState } from 'react'
import { useForm } from 'react-hook-form'
import toast from 'react-hot-toast'
import { useNavigate } from 'react-router-dom'
import { getUserProfil, HOME, resetStorage } from '../../Utils/Utils'
import { EDIT_USER_CREDENTIALS } from '../../Utils/constant'
import { SubmitButton } from '../../components/Widget/SubmitButton'
import { store } from '../../services/service'

const Profil = () => {
    const userInfo = getUserProfil()

    const {
        register,
        handleSubmit, reset,
        formState: { errors },
    } = useForm()
    const [isSubmit, setIsSubmit] = useState(false);
    const navigate = useNavigate()
    const submit = (data) => {
        setIsSubmit(true)
        store(EDIT_USER_CREDENTIALS, 'application/json', { ...data, username: userInfo?.username }).then((res) => {
            if (res.status === 200) {
                reset()
                setIsSubmit(null)
                toast.success('Mot de passe modifié')
                resetStorage()
                navigate(`${HOME}/login`)
            }
        }).catch((err) => {
            setIsSubmit(false)
            toast.error(err?.response?.data?.donnee, { duration: 4000 })
        })
    }

    return (
        <div className=''>
            <div className="lg:flex gap-4 items-center">
                <button className='btn bg-white  btn-sm' onClick={() => { window.history.back() }}><CaretLeftIcon /></button>
                <h1 className='text-3xl font-bold font-mtn'>Modification de mot de passe</h1>
            </div>

            <div className='mt-8 rounded-xl w-full lg:w-fit p-4 bg-white mx-auto'>
                <div class="space-y-6">
                    <form class="space-y-2" onSubmit={handleSubmit(submit)} >

                        <div class="">
                            <label className="text-sm font-medium">Ancien mot de passe <span className="text-red-500">*</span></label>

                            <div className='mt-2'>
                                <input
                                    {...register('password', { required: true })}
                                    type="password"
                                    placeholder="Ancien mot de passe"
                                    className="input input-bordered w-full lg:w-96 h-10 text-sm "
                                />
                            </div>
                        </div>


                        <div class="">
                            <label className="text-sm font-medium">Nouveau mot de passe <span className="text-red-500">*</span></label>
                            <div className='mt-2'>
                                <input
                                    {...register('newPassword', { required: true })}
                                    type="password"
                                    placeholder="Nouveau mot de passe"
                                    className="input input-bordered w-full lg:w-96 h-10 text-sm "
                                />
                            </div>
                        </div>


                        <div class="">
                            <label className="text-sm font-medium">Confirmer le mot de passe <span className="text-red-500">*</span></label>
                            <div className='mt-2'>
                                <input
                                    {...register('passwordConfirm', { required: true })}
                                    type="password"
                                    placeholder="Confirmer mot de passe"
                                    className="input input-bordered w-full lg:w-96 h-10 text-sm "
                                />
                            </div>
                        </div>

                        <div className='mt-8'>
                            <SubmitButton isSubmit={isSubmit} label={'Modifier'} />
                        </div>
                    </form>
                </div>

            </div>
        </div>
    )
}

export default Profil